import React from 'react'

export default class SubjectMarker extends React.Component {
  componentWillMount() {
    const { addToMarkers, map, position, processStreetView, calculateHeadingAfterSubjectMarkerMove } = this.props

    this.marker = new (google.maps.Marker)({
      position,
      icon: 'https://maps.google.com/mapfiles/ms/micons/man.png',
      zIndex: 102,
      draggable: true,
      visible: this.isVisible(this.props),
      map
    })

    addToMarkers('subject', this.marker)

    google.maps.event.addListener(this.marker, 'mouseup', _ => {
      processStreetView()
      calculateHeadingAfterSubjectMarkerMove()
    })
  }

  componentWillReceiveProps(newProps) {
    const { position, visible, locked } = newProps

    if (this.props.position.lat() !== position.lat() ||
        this.props.position.lng() !== position.lng()) {
      this.marker.setPosition(position)
    }

    if (this.props.visible !== visible || locked !== this.props.locked) {
      this.marker.setVisible(this.isVisible(newProps))
    }
  }

  isVisible({ visible, locked }) {
    return !locked && visible && !EXPORT
  }

  shouldComponentUpdate() {
    return false
  }

  render() {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/components/Camera/SubjectMarker.js